export default "__VITE_ASSET__c17c1e04__"